export var UpsertConnectedAppResult;
(function (UpsertConnectedAppResult) {
    UpsertConnectedAppResult[UpsertConnectedAppResult["ResourceIsNotAvailable"] = -11] = "ResourceIsNotAvailable";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AnotherAppWithGivenAccessTokenAlreadyExists"] = -10] = "AnotherAppWithGivenAccessTokenAlreadyExists";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AppGuidDoesNotExists"] = -7] = "AppGuidDoesNotExists";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AppUrlToShort"] = -6] = "AppUrlToShort";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AppUserNameToShort"] = -5] = "AppUserNameToShort";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AppUserIdToShort"] = -4] = "AppUserIdToShort";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AccessTokenToShort"] = -3] = "AccessTokenToShort";
    UpsertConnectedAppResult[UpsertConnectedAppResult["AppNameToShort"] = -2] = "AppNameToShort";
    UpsertConnectedAppResult[UpsertConnectedAppResult["UnkownError"] = 0] = "UnkownError";
    UpsertConnectedAppResult[UpsertConnectedAppResult["Changed"] = 1] = "Changed";
})(UpsertConnectedAppResult || (UpsertConnectedAppResult = {}));
export class ConnectedApp {
    constructor() {
        this.Guid = "";
        this.AppName = "";
        this.AppUrl = "";
        this.AccessToken = "";
        this.IsAccessEnabled = false;
        this.AppUserName = "";
        this.AppUserId = "";
    }
}
//# sourceMappingURL=IConnectedAppsService.js.map